import React from 'react';
import { ReferentIndex } from '../../../../_common/referent';

export const Step3 = ({ monReferentRequirements, setMonReferentRequirements }) => {
    return <ReferentIndex monReferentRequirements={monReferentRequirements} setMonReferentRequirements={setMonReferentRequirements} hasFooter={true}/>
}